import * as React from "react";
import { AdminLevelList, ConsultantLevelList, doesUserHaveAccess } from "../../model/UserDetails.model";
import { UserTypeEnum } from "../../model/UserInfo.model";
import { handleEnter } from "../../utils/commonUtil";
import { OktaLogOut } from "./OktaLogout";
import { getConfig } from "../../utils/envUtil";
import {useNavigate} from "react-router-dom";
import {navigateTo} from "../../../navigateTo";

export interface IMenuProps {
    username?: string;
    shown: boolean;
    closeMenuFn: () => void;
    userType: UserTypeEnum;
    hasRaAccess: boolean;
    setCorsErrorModalOpen: (is: boolean) => void;
}

const truncateUsernameText = (username: string): string => username.substring(0, 25);

export const Menu: React.FC<IMenuProps> = (props) => {
    const navigate = useNavigate();
    const getTabIndex = () => (props.shown ? 0 : -1);

    const navigateAndCloseMenu = (path: string) => {
        navigateTo(path, navigate);
        props.closeMenuFn();
    };

    const renderAdminLinks = () => {
        if (!doesUserHaveAccess(props.userType, AdminLevelList)) return null;
        return (
            <div>
                <div className="clickable-menu-item">
                    <a
                        className="admin-page-link old-anchor"
                        tabIndex={getTabIndex()}
                        onKeyUp={handleEnter(() => navigateAndCloseMenu("/admin"))}
                        onClick={() => navigateAndCloseMenu("/admin")}
                    >
                        User Administration
                    </a>
                </div>
                <div className="clickable-menu-item">
                    <a
                        className="admin-client-plan-link old-anchor"
                        tabIndex={getTabIndex()}
                        onKeyUp={handleEnter(() => navigateAndCloseMenu("/admin-client-plan"))}
                        onClick={() => {navigateAndCloseMenu("/admin-client-plan");}}
                    >
                        Client Plan Administration
                    </a>
                </div>
                <div className="clickable-menu-item">
                    <a
                        className="admin-upload-page-link old-anchor"
                        tabIndex={getTabIndex()}
                        onKeyUp={handleEnter(() => navigateAndCloseMenu("/admin-upload"))}
                        onClick={() => {navigateAndCloseMenu("/admin-upload");}}
                    >
                        Upload Files
                    </a>
                </div>
                <div className="clickable-menu-item">
                    <a
                        className="admin-media-groups-page-link old-anchor"
                        tabIndex={getTabIndex()}
                        onKeyUp={handleEnter(() => navigateAndCloseMenu("/admin-media-groups"))}
                        onClick={() => {navigateAndCloseMenu("/admin-media-groups");}}
                    >
                        CPR Media Group Admin
                    </a>
                </div>
            </div>
        );
    };

    const renderRiskAnalyzerLink = () => {
        if (!props.hasRaAccess) return null;
        return (
            <div className="clickable-menu-item">
                <a
                    className="risk-analyzer-link old-anchor"
                    onClick={() => window.open(getConfig().FRONTEND_CONFIG_RISK_ANALYZER_URL, "_blank")}
                    onKeyUp={handleEnter(() => window.open(getConfig().FRONTEND_CONFIG_RISK_ANALYZER_URL, "_blank"))}
                    tabIndex={getTabIndex()}
                >
                    Risk Analyzer
                </a>
            </div>
        );
    };

    const renderMyClientsPageLink = () => {
        if (!doesUserHaveAccess(props.userType, [...ConsultantLevelList, UserTypeEnum.ATC_ADMIN])) return null;
        return (
            <div className="clickable-menu-item">
                <a
                    className="old-anchor"
                    id="my-clients-link"
                    tabIndex={getTabIndex()}
                    onKeyUp={handleEnter(() => navigateAndCloseMenu("/my-clients"))}
                    onClick={() => {navigateAndCloseMenu("/my-clients");}}
                >
                    My Clients
                </a>
            </div>
        );
    };

    const getMenuClass = () => "header__menu--" + (props.shown ? "shown" : "hidden");

    if (!props.username) {
        return <div />;
    }

    return (
        <div id="user-menu__container" data-testid="user-menu__container">
            {props.shown && <div className="menu__overlay" onClick={props.closeMenuFn} />}
            <div id="menu" className={getMenuClass()} data-testid="menu">
                <div className="title-bar">
                    <div className="close-icon fa-regular fa-x" onClick={props.closeMenuFn} />
                </div>
                <div className="username-card">
                    <div className="user-info" id="username" data-testid="username">
                        <div className="user-icon fa-light fa-user" />
                        {truncateUsernameText(props.username)}
                    </div>
                    {renderMyClientsPageLink()}
                    {renderAdminLinks()}
                    {renderRiskAnalyzerLink()}
                    <OktaLogOut setCorsErrorModalOpen={props.setCorsErrorModalOpen} />
                </div>
            </div>
        </div>
    );
};